module.exports = __webpack_public_path__ + "static/media/icon_real_time_channel461d16e4f543491157c1bdb0a1c63042.webp";